import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueResource from "vue-resource"
import colors from 'vuetify/lib/util/colors'
// import 'material-design-icons/iconfont/material-icons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
// import 'font-awesome/css/font-awesome.min.css'
// import 'font-awesome/css/font-awesome.css'
import '@fortawesome/fontawesome-free/css/all.css'

// import "echarts";

Vue.use(Vuetify);
Vue.use(VueResource)

export default new Vuetify({
    icons: {
    iconfont: 'mdi', 
    },
    theme: {
    themes: {
        light: {
            primary: "#3a687f",
            primaryDark: "#1a5d7f",
            secondary: colors.blue.lighten2,
            accent: "#f7a823",
            error: colors.red.accent3,
            b1:"#f5f7f9",
            b2:"#C9C9C9",
        },
        dark: {
            primary: colors.blue.lighten3,
        },
    },
    },
});
